import React from 'react';

export interface TaskItem {
    id: string;
    client: string;
    task: string;
    due: string;
    priority: 'high' | 'medium' | 'low';
}

interface TaskWidgetProps {
    tasks: TaskItem[];
    onViewAll?: () => void;
}

export const TaskWidget: React.FC<TaskWidgetProps> = ({
    tasks,
    onViewAll
}) => {
    return (
        <div className="bg-white portal-content-shadow rounded-lg shadow-sm border border-gray-200 p-6 h-full">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold text-gray-900">Client Tasks</h2>
                <button
                    onClick={onViewAll}
                    className="text-sm font-medium text-blue-600 hover:text-blue-700"
                >
                    View all tasks →
                </button>
            </div>
            <div className="space-y-3">
                {tasks.length > 0 ? (
                    tasks.map((task, index) => (
                        <div
                            key={index}
                            className="flex items-center justify-between p-3 rounded-lg border border-gray-200 hover:border-gray-300 transition-colors"
                        >
                            <div className="flex-1">
                                <p className="text-sm font-medium text-gray-900">{task.task}</p>
                                <p className="text-xs text-gray-600 mt-1">{task.client}</p>
                            </div>
                            <div className="flex items-center space-x-3">
                                <span className={`text-xs font-medium px-2 py-1 rounded-full ${task.priority === 'high' ? 'bg-red-100 text-red-700' :
                                        task.priority === 'medium' ? 'bg-amber-100 text-amber-700' :
                                            'bg-gray-100 text-gray-700'
                                    }`}>
                                    {task.priority}
                                </span>
                                <span className="text-xs text-gray-500">{task.due}</span>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center py-8 text-gray-500 text-sm">
                        No pending tasks
                    </div>
                )}
            </div>
        </div>
    );
};
